"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_TYPE_WIDGET = void 0;
var axios_1 = require("axios");
var debounce = require("lodash.debounce");
var commonProperties_1 = require("./commonProperties");
exports.PAGE_TYPE_WIDGET = 'wigdet';
var StatsApi = /** @class */ (function () {
    function StatsApi(urlStatsApi) {
        var _this = this;
        this.InitializeCatalogsImpression = function (_a) {
            var SearchCity = _a.SearchCity, _b = _a.SearchWord, SearchWord = _b === void 0 ? 'tiendeo' : _b, Platform = _a.Platform, Origin = _a.Origin, Provider = _a.Provider, View = _a.View, PageType = _a.PageType, _c = _a.SearchType, SearchType = _c === void 0 ? 'undefined' : _c, _d = _a.IntegrationName, IntegrationName = _d === void 0 ? 'undefined' : _d, VariantName = _a.VariantName;
            _this.CatalogsImpression = {
                CatalogIds: [],
                CatalogPositions: [],
                CatalogModelNames: [],
                CatalogPages: [],
                SearchCity: SearchCity,
                SearchWord: SearchWord,
                PageType: PageType,
                Platform: Platform,
                Provider: Provider,
                Origin: Origin,
                SearchType: SearchType,
                Integration: IntegrationName || Provider,
                View: View,
                VariantName: VariantName
            };
        };
        this.PushCatalog = function (_a) {
            var CatalogId = _a.CatalogId, Position = _a.Position, ModelName = _a.ModelName, PageNumber = _a.PageNumber, getCookie = _a.getCookie, setCookie = _a.setCookie;
            _this.CatalogsImpression.CatalogIds.push(CatalogId);
            _this.CatalogsImpression.CatalogPositions.push(Position);
            _this.CatalogsImpression.CatalogModelNames.push(ModelName);
            if (PageNumber) {
                _this.CatalogsImpression.CatalogPages.push(PageNumber);
            }
            _this.PostCatalogsImpression(getCookie, setCookie);
        };
        this.PostCatalogsImpression = debounce(function (getCookie, setCookie) {
            var payload = __assign(__assign({}, _this.CatalogsImpression), commonProperties_1.default(getCookie, setCookie));
            _this.CatalogsImpression.CatalogIds = [];
            _this.CatalogsImpression.CatalogPositions = [];
            _this.CatalogsImpression.CatalogModelNames = [];
            _this.CatalogsImpression.CatalogPages = [];
            return axios_1.default.post(_this.baseUrl + '/Catalog/Print', payload);
        }, 250);
        this.InitializeArticlesImpression = function (_a) {
            var SearchCity = _a.SearchCity, Origin = _a.Origin, Platform = _a.Platform, Provider = _a.Provider, _b = _a.SearchWord, SearchWord = _b === void 0 ? 'undefined' : _b, Integration = _a.Integration, PageType = _a.PageType, _c = _a.SearchType, SearchType = _c === void 0 ? 'undefined' : _c, VariantName = _a.VariantName, Filter = _a.Filter;
            _this.ArticlesImpression = { SearchCity: SearchCity, Origin: Origin, Platform: Platform, Provider: Provider, SearchWord: SearchWord, Integration: Integration, PageType: PageType, SearchType: SearchType, VariantName: VariantName, Filter: Filter };
            _this.ArticlesImpression.Articles = [];
        };
        this.InitializeProductsViewArticlesImpression = function (_a) {
            var PageType = _a.PageType, Integration = _a.Integration, Platform = _a.Platform, Provider = _a.Provider, VariantName = _a.VariantName, SearchCity = _a.SearchCity, SearchType = _a.SearchType, SearchWord = _a.SearchWord, Origin = _a.Origin;
            _this.ProductsViewArticlesImpression = {
                Common: {
                    PageType: PageType,
                    Integration: Integration,
                    Platform: Platform,
                    Provider: Provider,
                    VariantName: VariantName,
                    SearchCity: SearchCity,
                    SearchType: SearchType,
                    SearchWord: SearchWord,
                    Origin: Origin,
                },
                Articles: [],
            };
        };
        this.PushArticle = function (_a) {
            var ItemType = _a.ItemType, ArticleId = _a.ArticleId, SaleId = _a.SaleId, ProductId = _a.ProductId, CatalogId = _a.CatalogId, BrandId = _a.BrandId, Position = _a.Position, View = _a.View, ModelName = _a.ModelName, getCookie = _a.getCookie, setCookie = _a.setCookie;
            _this.ArticlesImpression.Articles.push({
                ItemType: ItemType,
                ArticleId: ArticleId,
                SaleId: SaleId,
                ProductId: ProductId,
                CatalogId: CatalogId,
                BrandId: BrandId,
                Position: Position,
                View: View,
                ModelName: ModelName,
            });
            _this.PostArticlesImpression(getCookie, setCookie);
        };
        this.PushProductsViewArticle = function (_a) {
            var ItemType = _a.ItemType, ArticleId = _a.ArticleId, SaleId = _a.SaleId, ProductId = _a.ProductId, CatalogId = _a.CatalogId, BrandId = _a.BrandId, Position = _a.Position, View = _a.View, ModelName = _a.ModelName, Filter = _a.Filter, getCookie = _a.getCookie, setCookie = _a.setCookie;
            _this.ProductsViewArticlesImpression.Articles.push({
                ItemType: ItemType,
                ArticleId: ArticleId,
                SaleId: SaleId,
                ProductId: ProductId,
                CatalogId: CatalogId,
                BrandId: BrandId,
                Position: Position,
                View: View,
                ModelName: ModelName,
                Filter: Filter
            });
            _this.PostProductsViewArticlesImpression(getCookie, setCookie);
        };
        this.PostArticlesImpression = debounce(function (getCookie, setCookie) {
            var payload = __assign(__assign({}, _this.ArticlesImpression), commonProperties_1.default(getCookie, setCookie));
            _this.ArticlesImpression.Articles = [];
            return axios_1.default.post(_this.baseUrl + '/Article/Impressions', payload);
        }, 250);
        this.PostProductsViewArticlesImpression = debounce(function (getCookie, setCookie) {
            var payload = __assign(__assign(__assign({}, _this.ProductsViewArticlesImpression.Common), commonProperties_1.default(getCookie, setCookie)), { Articles: _this.ProductsViewArticlesImpression.Articles });
            _this.ProductsViewArticlesImpression.Articles = [];
            return axios_1.default.post(_this.baseUrl + '/Article/Impressions', payload);
        }, 250);
        this.InitializeStoresImpression = function (_a) {
            var SearchCity = _a.SearchCity, _b = _a.SearchWord, SearchWord = _b === void 0 ? 'undefined' : _b, Platform = _a.Platform, Origin = _a.Origin, Provider = _a.Provider, Integration = _a.Integration, View = _a.View, PageType = _a.PageType, _c = _a.SearchType, SearchType = _c === void 0 ? 'undefined' : _c;
            _this.StoresImpression = { SearchCity: SearchCity, SearchWord: SearchWord, Platform: Platform, Origin: Origin, Provider: Provider, Integration: Integration, View: View, PageType: PageType, SearchType: SearchType };
            _this.StoresImpression.Stores = [];
        };
        this.PushStore = function (_a) {
            var StoreId = _a.StoreId, Position = _a.Position, getCookie = _a.getCookie, setCookie = _a.setCookie;
            _this.StoresImpression.Stores.push({ StoreId: StoreId, Position: Position });
            _this.PostStoresImpression(getCookie, setCookie);
        };
        this.PostStoresImpression = debounce(function (getCookie, setCookie) {
            var payload = __assign(__assign({}, _this.StoresImpression), commonProperties_1.default(getCookie, setCookie));
            _this.StoresImpression.Stores = [];
            return axios_1.default.post(_this.baseUrl + '/Store/Impressions', payload);
        }, 250);
        this.PushPromoCoupon = function (_a) {
            var Position = _a.Position, PromoCouponId = _a.PromoCouponId, Type = _a.Type, getCookie = _a.getCookie, setCookie = _a.setCookie;
            _this.PromoCouponsImpression.PromoCoupons.push({
                Position: Position,
                PromoCouponId: PromoCouponId,
                Type: Type
            });
            _this.PostPromoCouponsImpression(getCookie, setCookie);
        };
        this.PostPromoCouponsImpression = debounce(function (getCookie, setCookie) {
            var payload = __assign(__assign({}, _this.PromoCouponsImpression), commonProperties_1.default(getCookie, setCookie));
            var searchParams = new URLSearchParams(window.location.search);
            if (window.location.pathname.includes("cashback")) {
                payload.View = "offers-cashback";
                if (searchParams) {
                    var retailer = searchParams.get("retailer");
                    var category = searchParams.get("category");
                    if (retailer) {
                        if (category)
                            payload.SearchWord = retailer + '&' + category;
                        else
                            payload.SearchWord = retailer;
                    }
                    else if (category)
                        payload.SearchWord = category;
                }
                else
                    payload.SearchWord = "cashback";
            }
            _this.PromoCouponsImpression.PromoCoupons = [];
            return axios_1.default.post(_this.baseUrl + '/Promocoupon/Impressions', payload);
        }, 250);
        this.baseUrl = urlStatsApi + "_statsapi/v1";
        this.ArticlesImpression = undefined;
        this.CatalogsImpression = undefined;
        this.StoresImpression = undefined;
    }
    ;
    StatsApi.prototype.InitializePromoCouponImpression = function (_a) {
        var Integration = _a.Integration, Origin = _a.Origin, PageType = _a.PageType, Platform = _a.Platform, Provider = _a.Provider, SearchCity = _a.SearchCity, _b = _a.SearchType, SearchType = _b === void 0 ? 'undefined' : _b, _c = _a.SearchWord, SearchWord = _c === void 0 ? 'undefined' : _c, View = _a.View;
        this.PromoCouponsImpression = {
            Integration: Integration,
            Origin: Origin,
            PageType: PageType,
            Platform: Platform,
            Provider: Provider,
            PromoCoupons: [],
            SearchCity: SearchCity,
            SearchType: SearchType,
            SearchWord: SearchWord,
            View: View,
        };
    };
    return StatsApi;
}());
exports.default = StatsApi;
//# sourceMappingURL=statsApi.js.map